import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { envAwarePost } from "../../util/util";

export const getClasses = createAsyncThunk("getClasses", 
  async (payload) => envAwarePost("api/schedule/api.php",{
      action: "getClubreadySchedule",
      ...payload,
  })
);
export const bookClass = createAsyncThunk("bookClass", 
  async (payload,{dispatch}) => {
    const res = await envAwarePost("api/schedule/api.php",{
      action: "clubreadyClassSignup",
      ...payload,
    })
    //it's possible that a user booked this class through
    //some other means and we won't have a record of it.
    //The api will detect this and create a record & then
    //notify the frontend that a refresh is needed.
    //dispatch a refresh here. 
    if(res?.data?.should_refresh){
      dispatch(getClasses())
    }
    return res
  }
);
export const cancelBooking = createAsyncThunk("cancelClass", 
  async (payload) => envAwarePost("api/schedule/api.php",{
      action: "cancelClubreadyBooking",
      ...payload,
  })
);

const maxClassScheduleSlice = createSlice({
  name: "classes",
  initialState: {
    classList: [],
    classListStatus: "idle",
    bookingStatus: "idle",
  },
  reducers: {},
  extraReducers: {
    [getClasses.pending]: (state, action) => {
      state.classListStatus = "fetching";
    },
    [getClasses.fulfilled]: (state, action) => {
      const { success, data } = action.payload;
      if (success == 1) {
        state.classList = data;
        state.classListStatus = "idle";
      }
    },
    [getClasses.rejected]: (state, action) => {
      state.classListStatus = "failed";
    },
    [bookClass.pending] : (state, action) => {
        state.bookingStatus = "fetching"
    },
    [bookClass.fulfilled] : (state, action) => {
        state.bookingStatus = "idle";
        let requiredClass = state.classList.find(classData => classData.ScheduleId == action.meta.arg.class_schedule_id);
        if(action.payload.success == "1"){
          requiredClass.booking_status = action.payload.data.BookingId > 0 ? 1 : 2;
          requiredClass.BookingId = action.payload.data.BookingId;
          requiredClass.IsBooked = true;
        }else{
          alert(action.payload.message)
        }
        
    },
    [bookClass.rejected] : (state, action) => {
        state.bookingStatus = "failed"
    },
    [cancelBooking.pending] : (state, action) => {
        state.bookingStatus = "fetching"
    },
    [cancelBooking.fulfilled] : (state, action) => {
        state.bookingStatus = "idle";
        let requiredClass = state.classList.find(classData => classData.ScheduleId == action.meta.arg.class_schedule_id);
        if(action.payload.success == "1"){
            requiredClass.booking_status = 0;
            requiredClass.IsBooked = false;
            requiredClass.BookingId = null;
        }      
    },
    [cancelBooking.rejected] : (state, action) => {
        state.bookingStatus = "failed"
    },
  },
});

export default maxClassScheduleSlice.reducer;
